import React from 'react';

const CommentsListItemBody = ({ body, editable, UpdateForm }) => (
  <div>
    { (editable && UpdateForm) || <p className="f--2 f--1-ns t-mt1 lh-copy fw3">{body}</p> }
  </div>
);

CommentsListItemBody.defaultProps = {
  body: 'defaultBody',
  editable: false,
  UpdateForm: 'Update Form'
};

export default CommentsListItemBody;
